import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import moment from 'moment';
import _ from 'lodash';

export const TRANSACTION_FAILURE = 'TRANSACTION/TRANSACTION_FAILURE';
export const TRANSACTION_LOAD = 'TRANSACTION/TRANSACTION_LOAD';
export const TRANSACTION_SUCCESS = 'TRANSACTION/TRANSACTION_SUCCESS';
export const CHECK_FOR_LINKED_REFUND_FAILURE = 'TRANSACTION/CHECK_FOR_LINKED_REFUND_FAILURE';
export const CHECK_FOR_LINKED_REFUND_LOADING = 'TRANSACTION/CHECK_FOR_LINKED_REFUND_LOADING';
export const CHECK_FOR_LINKED_REFUND_SUCCESS = 'TRANSACTION/CHECK_FOR_LINKED_REFUND_SUCCESS';

export function getTransaction(transactionId) {
    return {
        failureActionTypeOrCreator: getTransactionFailureActionCreator,
        fetchParams: {
            url: `${config.transactionsApiUrl}/${transactionId}`
        },
        loadActionTypeOrCreator: TRANSACTION_LOAD,
        successActionTypeOrCreator: getTransactionSuccessActionCreator
    };
}

export function getTransactionFailureActionCreator(error) {
    return {
        error,
        type: TRANSACTION_FAILURE
    };
}

export function getTransactionSuccessActionCreator(transaction) {
    return {
        transaction,
        type: TRANSACTION_SUCCESS
    };
}

export function checkForLinkedRefunds(transaction) {
    const originalTransactionId = _.get(transaction, 'id');
    const startDate = moment(_.get(transaction, 'transactionDate')).format();
    const endDate = moment(startDate).add(6, 'months').format();

    const filters = [
        {
            id: 'originalTransactionId',
            value: originalTransactionId
        },
        {
            id: 'startDate',
            value: startDate
        },
        {
            id: 'endDate',
            value: endDate
        }
    ];

    const foreignCurrencyId = _.get(transaction, 'foreignProcessingCurrency.currencyId');
    if (foreignCurrencyId) {
        filters.push({
            id: 'foreignProcessingCurrency.currencyId',
            value: foreignCurrencyId
        });
    }

    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters
    });

    return {
        fetchParams: {
            method: 'GET',
            url: `${config.transactionsApiUrl}${queryParamsString}`
        },
        failureActionTypeOrCreator: (error) => ({
            type: CHECK_FOR_LINKED_REFUND_FAILURE,
            error
        }),
        loadActionTypeOrCreator: () => ({
            type: CHECK_FOR_LINKED_REFUND_LOADING
        }),
        successActionTypeOrCreator: (results) => ({
            type: CHECK_FOR_LINKED_REFUND_SUCCESS,
            results
        })
    };
}
